module.exports = __webpack_public_path__ + "static/AnyBit-3a7a447714a7597925243f8c70c633e8.png";